import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';


@Injectable()
export class VisioGuard implements CanActivate {
  constructor(private router: Router) {
  }

  canActivate() {
    if (localStorage.getItem('canStartVisio') !== 'true') {
      this.router.navigate(['/dossier']);
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/guard/visio.guard.ts